import { Suspense, FC, HTMLAttributes, PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import { Loader } from '../loader';
import { useMessage } from '../../i18n/useMessage';
import { useAppData } from '../../context/app-context';

const Layout = styled.main`
  height: 100%;
  position: relative;
  overflow-y: auto;
`;

export interface RemoteModuleProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onError'> {
  documentTitle?: string;
}

export const RemoteModule: FC<PropsWithChildren<RemoteModuleProps>> = ({ documentTitle, children, ...props }) => {
  const t = useMessage();
  const { programmableMediaLogger } = useAppData();

  return (
    <Layout {...props}>
      <Helmet title={documentTitle ? `${documentTitle} | ${t('default-page-title')}` : t('default-page-title')} />

      <programmableMediaLogger.ErrorBoundary errorBoundaryLogLabel={`Federated Module: ${documentTitle}`} data-test="remote-module-error">
        <Suspense fallback={<Loader />}>{children}</Suspense>
      </programmableMediaLogger.ErrorBoundary>
    </Layout>
  );
};
